<template>
  
</template>
<script>
import Axios from 'axios';
import { eventBus } from '@/assets/js/eventBus';
export default {
  created(){
    var that = this;
    Axios.get(that.$store.state.APIURLS+"Wx/getSignature?url="+encodeURIComponent(location.href.split('#')[0])).then((res) => {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature,// 必填，签名
        jsApiList: ["updateAppMessageShareData","updateTimelineShareData"] // 必填，需要使用的JS接口列表
      });
    });
  },
  mounted() {
    const that = this;
    eventBus.$on("shareList",(val) => {
      wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({ 
          title: val.title, // 分享标题
          desc: val.content.replace(/<\/?[^>]*>/gim,"").replace(/&nbsp;/g, ""), // 分享描述
          link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "http://www.zswtbj.com/shareimg.png", // 分享图标
          success: function () {
          // 设置成功
          }
        })
        wx.updateTimelineShareData({ 
          title: val.title, // 分享标题
          link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "http://www.zswtbj.com/shareimg.png", // 分享图标
          success: function () {
          // 设置成功
          }
        })
      });   
    });
  },
}
</script>